import {CustomStatistics} from "../../../../lib/custom-statistics/custom-statistics";
import {CustomStatisticsRightModel} from "../../../../lib/custom-statistics/custom-statistics-right.model";
import {GrantedPermissionSetResolver} from "../../../../lib/right.service";

export class TaskRecordCustomStatisticsModel {
  selectedStatistics?: CustomStatistics.CustomStatistics;
  createNew: boolean = false;
  grantedRights: CustomStatisticsRightModel = new CustomStatisticsRightModel(GrantedPermissionSetResolver.empty());
  updateInProgress: boolean = false;
  diagramModels: TaskRecordCustomStatisticsDiagramModel[] = [];
  name: string = '';
  externalId: string = '';
  query: string = '';

  get selectedStatisticsId(): number | undefined {
    return this.selectedStatistics?.id;
  }

  get editingInProgress(): boolean {
    return this.updateInProgress || this.createNew;
  }

  reset() {
    this.grantedRights = new CustomStatisticsRightModel(GrantedPermissionSetResolver.empty());
    this.selectedStatistics = undefined;
    this.createNew = false;
    this.updateInProgress = false;
    this.diagramModels = [];
    this.externalId = '';
    this.name = '';
  }

  resetToSelected() {
    this.createNew = false;
    this.updateInProgress = false;
  }
}

export class TaskRecordCustomStatisticsDiagramModel {
  formFieldId: number;
  name: string;
}
